export function circles() {
	document.addEventListener('DOMContentLoaded', () => {
		const circles = document.querySelectorAll('[data-circles-item]')

		circles.forEach(circle => {
			const content = circle.querySelector('[data-circles-content]')
			if (!content) return

			const hasOverflow = content.scrollHeight > content.clientHeight
			if (!hasOverflow) return

			circle.classList.add('has-overflow')

			let direction = 1 
			let start = null

			function animateScroll(timestamp) {
				if (!start) start = timestamp

				const maxScroll = content.scrollHeight - content.clientHeight
				const duration = 3000 // time to go full top→bottom or bottom→top
				const progress = (timestamp - start) / duration

				if (progress < 1) {
					content.scrollTop = direction === 1 ? maxScroll * progress : maxScroll * (1 - progress)
					requestAnimationFrame(animateScroll)
				} else {
					content.scrollTop = direction === 1 ? maxScroll : 0
					direction *= -1
					start = null
					setTimeout(() => requestAnimationFrame(animateScroll), 1000)
				}
			}

			animateScroll()
		})
	})
}
